import type { ArticleIdSource } from '@pressreader/content-types';

export function resolveArticleGroupId<TArticle extends ArticleIdSource>(article: TArticle): string {
    return article.primaryArticleId || article.id;
}
